import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { takeUntil } from 'rxjs';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

import { Aggregation, Aggregations, Filter } from '../../filters';
import { AbstractFilterComponent } from '../abstract-filter.component';

@Component({
  selector: 'cbre-equal-filter',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule
],
  templateUrl: './equal.component.html',
  styleUrl: './equal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EqualFilterComponent extends AbstractFilterComponent {
  readonly aggregations = input<Aggregations>({});

  protected _aggregations: Aggregations;

  constructor() {
    super();
    effect(() => {
      const aggs = this.aggregations();
      this._aggregations = aggs ?? {};
      if (this.filter$()?.inputType === 'dropdown') this._setUpFilterOptions();
    });
  }

  protected _setUpFilter() {
    if (this.filter$() == null || this._form == null) return;

    this.control = this._form.get(this.filter$().key) as FormControl;

    this._reset$.next(true);
    this.control.valueChanges
      .pipe(takeUntil(this._reset$), takeUntilDestroyed(this.destroyRef))
      .subscribe(this._checkValuePresence);
  }

  protected _setUpFilterOptions() {
    const aggregation = this._aggregations[this.filter$()?.key] ?? [];

    this.options = aggregation
      .filter(a => a?.key != null)
      .map(option => ({
        label: this._makeOptionLabel(this.filter$(), option),
        value: this._makeOptionValue(option),
      }));
    this._checkValuePresence();
  }

  public handleChange(): void {
    this._checkValuePresence();
  }

  protected _makeOptionLabel = ({ dataType }: Pick<Filter, 'dataType'>, { key, value, displayName }: Aggregation) => {
    const count = value == null || isNaN(Number(value)) ? '' : ` (${Number(value)})`;
    const label =
      dataType === 'boolean' && !displayName
        ? `${this._keyValue(key)}${count}`
        : // convert y/n if boolean, else default
          `${displayName || key}${count}`;

    return label.toUpperCase();
  };

  protected _keyValue = key => {
    if (key === '1') return 'Y';
    return key === '0' ? 'N' : key;
  };

  protected _makeOptionValue = ({ key }: Aggregation) => key;
}
